import React from "react";
import { connect } from "react-redux";
import "../css/hoverGrid.css";

const HoverGrid = ({ gridData }) => {
  if (!gridData || gridData.length === 0) return null; 

  return (
    <div className="hover-grid-container">
      {/* Heading Section Above Grid */}
      <div className="grid-heading">
        <h2>Careers</h2>
        <p>We bring you powerful advantages to navigate your digital transformation</p>
      </div>

      <div className="hover-grid">
        {gridData.map((item, index) => (
          <div 
            key={index} 
            className={`grid-item ${item.is_large ? "large" : ""}`} 
            style={{ backgroundImage: `url(${item.image_url})` }}
          >
            <div className="overlay">
              <h3>{item.title}</h3>
              {item.subtitle && <p className="subtitle">{item.subtitle}</p>}
              {item.description && <p className="description">{item.description}</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gridData: state.gridData.data, 
});

export default connect(mapStateToProps)(HoverGrid);
